import { CommonKeys } from "../../../common/enums";
import { STAMM_BELEG_TYPE } from "../../interfaces/stammelements/StammElementBeleg";

export const FormularGroupStammStammElementBelegSchema = {
    $id: "FormularGroupStammStammElementBelegSchema",
    title: "FormularGroupStammStammElementBeleg Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_BELEG_TYPE },
                Property: { type: "number", nullable: true }
            }
        }
    ],
};